module.exports = __webpack_public_path__ + "img/C06TechSapperChampion_ua.14272094.webp";